module.exports = __webpack_public_path__ + "static/media/bundle_cart_up_arrow.983b9c61.svg";